// Module
var code = "<div><cc-payment-form-stripe ng-if=\"$ctrl.paymentProvider === 'STRIPE'\" stripe-api-key=\"$ctrl.stripeApiKey\" on-submit=\"$ctrl.onStripePayment(data)\" payment-in-process=\"$ctrl.paymentInProcess\" user-id=\"$ctrl.userId\" errors=\"$ctrl.errors\"></cc-payment-form-stripe></div>";
// Exports
var _module_exports =code;;
var path = 'app/components/payments/enterPayment.html';
var angular = require('angular');
angular.module('pims').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
export default path;